import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Select } from 'antd';
import InputSelectField from '../../../../../components/mobile/form-helpers/InputSelectField';
import HeaderScreening from '../../../../../components/mobile/sign-up/HeaderScreening';
import SharedWithList from '../../../../../components/mobile/medical-history/SharedWithList';
import { FormInputArea } from '../../../../../components/mobile/form-helpers/FormField';

const { Title } = Typography;

const data = [
  {label: 'Medication 1', value: 'Medication 1'},
  {label: 'Medication 2', value: 'Medication 2'},
  {label: 'Medication 3', value: 'Medication 3'},
  {label: 'Medication 4', value: 'Medication 4'},
]

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  }
}

function MobileMedicationsScreen({fieldName, step, count}) {
  const { t } = useTranslation(['medical-history', 'common']);
  const history = useHistory();
  const { values, setFieldValue } = useFormikContext();
  const [lists, setLists] = useState(values[fieldName]);

  const handleChange = (name, val) => {
    const data = {label: val, value: val};
    const arr = [...lists, data];
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  const onRemove = (val) => {
    const arr = lists.filter(function(obj) {
      return obj.value !== val;
    });
    setLists(arr);
    setFieldValue(fieldName, arr);
  }

  return (
    <>
      <HeaderScreening
        count={count}
        step={step}
        title={t('medical-history:medications.title')}
        subtitle={t('medical-history:medications.subtitle')}
      />
      <Divider />
      <Col xs={24}>
        <FormInputArea
          name={fieldName}
          style={{ width: '100%', padding: '3%' }}
          formItemLayout={formItemLayout}
          onChange={(e) => setFieldValue(fieldName, e.target.value)}
          value={values[fieldName]}
          rows={6}
        />
        {/* <InputSelectField
          name="temp_medications"
          label={t('medical-history:medications.form.enterMedicationName.label')}
          placeholder={t('medical-history:medications.form.enterMedicationName.placeholder')}
          options={data}
          handleChange={handleChange}
        />
        <Box>
          <SharedWithList
            title={t('medical-history:medications.form.yourMedication.label')}
            emptyTitle={t('medical-history:medications.form.yourMedication.noSelected')}
            list={lists}
            onRemove={onRemove} />
        </Box> */ }
      </Col>
    </>
  );
}

export default MobileMedicationsScreen;
